/* eslint-disable operator-assignment */
// import * as CryptoJS from 'crypto-js';
import { organizationProperties } from './constants';

const isProduction = process.env.NEXT_PUBLIC_HOME_REMOTE_CONFIG_ENV === 'PROD';

function getBaseDomain(hostname) {
  // Regular expression to match domain parts
  const domainParts = hostname.split('.');

  // If there are only two parts (like example.com), return the first part
  if (domainParts.length <= 2) {
    return domainParts[0];
  }

  // For domains with more than two parts (like www.example.co.uk or api.nextias.com),
  // you usually want the second-to-last part (the base domain).
  return domainParts[domainParts.length - 2];
}
function getRootDomainForCookie() {
  const { hostname } = window.location;

  // Split the hostname into parts
  const parts = hostname.split('.');

  // If it's an IP address or localhost, return as is
  if (parts.length <= 1 || hostname === 'localhost' || /^[\d.]+$/.test(hostname)) {
    return hostname;
  }

  // Handle known TLDs like .co.uk, .com.au (basic handling)
  const knownTwoPartTLDs = ['co.uk', 'com.au', 'co.in', 'gov.uk', 'ac.uk'];
  const lastTwo = parts.slice(-2).join('.');

  if (knownTwoPartTLDs.includes(lastTwo) && parts.length > 2) {
    return `.${parts.slice(-3).join('.')}`;
  }

  return `.${parts.slice(-2).join('.')}`;
}

function getCurrentOrganization() {
  const hostname = typeof window === 'undefined' ? 'nextias.com' : window.location.host;
  const baseDomain = getBaseDomain(hostname);

  const respProperties = organizationProperties[baseDomain] || {};
  if (!isProduction && !respProperties?.orgId) {
    // Use fallback dev org for non-prod environments
    return organizationProperties[process?.env?.NEXT_PUBLIC_FALLBACK_DEV_ORG || 'nextias'];
  }

  return respProperties;
}

function getOrganizationPropertiesByHost(host = 'nextias.com') {
  let baseDomain = getBaseDomain(host);
  // console.log({
  //   host,
  //   baseDomain,
  //   isProduction,
  // });

  if (!isProduction && !baseDomain) {
    baseDomain = process?.env?.NEXT_PUBLIC_FALLBACK_DEV_ORG || 'nextias';
  }

  if (organizationProperties[baseDomain]) {
    return organizationProperties[baseDomain] || {};
  }

  if (!isProduction) {
    // Use fallback dev org for non-prod environments
    return organizationProperties[process?.env?.NEXT_PUBLIC_FALLBACK_DEV_ORG || 'nextias'];
  }

  // Extreme fallback
  return {};
}
function getCookieValue(name) {
  const cookieName = `${encodeURIComponent(name)}=`;
  const cookieStart = document.cookie.indexOf(cookieName);
  let cookieValue = null;
  let cookieEnd;

  if (cookieStart > -1) {
    cookieEnd = document.cookie.indexOf(';', cookieStart);
    if (cookieEnd === -1) {
      cookieEnd = document.cookie.length;
    }
    cookieValue = decodeURIComponent(document.cookie
      .substring(cookieStart + cookieName.length, cookieEnd));
  }

  return cookieValue;
}

async function handleFetch(url, options = {}) {
  const organization = getCurrentOrganization();

  const token = getCookieValue('userToken');
  let authToken = {};
  const isCoreApiHost = url.includes(process.env.NEXT_PUBLIC_CORE_API_HOST);
  if (token) {
    authToken = isCoreApiHost
      ? {
        Authorization: `Bearer ${token}`,
        'device-type': '4',
        organization: organization?.orgId || '2410f924-6cc4-4e88-b490-ffd3bbc40d03',
        'account-role': 'student',
        'version-code': '22',
      } : {
        Auth: `Bearer ${token}`,
        // organization: organization?.orgId || '2410f924-6cc4-4e88-b490-ffd3bbc40d03',
        'device-type': '4',
        'Version-Code': '22',
      };
  }
  try {
    const response = await fetch(url, {
      // credentials: 'include',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...authToken,
        ...options?.headers,
      },
    });
    const data = await response.json();
    //  console.log("jdhfjdfhjdgfh", data);

    if (!response.ok) {
      if (response.status === 401) {
        throw new Error('401');
      } else {
        throw new Error(data?.message || data?.error?.message || 'An error occurred while fetching data.');
      }
    }

    return data;
  } catch (error) {
    console.error('Fetch Error:', error.message);
    console.log(error.message || 'Failed to fetch data.');
    throw error;
    // return false;
  }
}

// using xhr for file upload since fetch has limited support to track upload progress
async function handleFileUpload(url, file, contentType, onProgress, data = {}) {
  const formData = new FormData();

  // handle multiple files
  // files.forEach((file, index) => {
  //   formData.append(`files[${index}]`, file);
  // });

  formData.append('file', file);
  // console.log('csv', file);

  Object.keys(data).forEach((key) => {
    formData.append(key, data[key]);
  });

  try {
    const xhr = new XMLHttpRequest();
    xhr.open('PUT', url);
    xhr.setRequestHeader('Content-Type', contentType); // Set header
    xhr.withCredentials = true;
    // console.log(xhr);
    xhr.upload.onprogress = (event) => {
      if (event.lengthComputable) {
        const percentComplete = ((event.loaded / event.total) * 100).toFixed(2);
        if (onProgress) {
          onProgress(percentComplete);
        }
      }
    };

    return await new Promise((resolve, reject) => {
      xhr.onload = () => {
        try {
          // const response = JSON.parse(xhr.responseText);
          if (xhr.status === 200 || xhr.status === 201) {
            resolve({ success: true });
            // resolve(response);
          } else {
            reject(new Error(`File upload failed with status ${xhr.status}`));
            // reject(new Error(response?.message || 'File upload failed'));
          }
        } catch (error) {
          reject(new Error('Failed to parse response'));
        }
      };

      xhr.onerror = () => {
        reject(new Error('Error while uploading file'));
      };

      xhr.send(formData);
    });
  } catch (error) {
    console.log(error.message || 'Failed to upload files.');
    throw new Error(error.message || 'Failed to upload files.');
    // return false;
  }
}

// presinged upload function
async function handlePresignedUpload({
  url,
  fields,
  file,
  finalKey,
  onProgress,
  xhrStore = null,
  storeKey = null,
}) {
  return new Promise((resolve, reject) => {
    try {
      const formData = new FormData();

      // append AWS required fields
      fields.forEach((field) => formData.append(field.name, field.value));

      // these appended for S3 POST upload
      formData.append('Content-Type', file.type);
      formData.append('key', finalKey);
      formData.append('file', file);

      const xhr = new XMLHttpRequest();

      if (xhrStore && storeKey) {
        // eslint-disable-next-line no-param-reassign
        xhrStore[storeKey] = xhr;
      }

      xhr.open('POST', url);

      // Progress callback
      xhr.upload.onprogress = (event) => {
        if (event.lengthComputable && onProgress) {
          const percent = Math.round((event.loaded / event.total) * 100);
          onProgress(percent);
        }
      };

      xhr.onload = () => {
        if (xhr.status === 204) {
          resolve(finalKey); // success
        } else {
          reject(new Error(`Upload failed with status ${xhr.status}`));
        }
      };

      xhr.onerror = () => {
        reject(new Error('Network error while uploading file.'));
      };

      xhr.send(formData);
    } catch (error) {
      reject(error);
    }
  });
}

//

function noop() { }

function getUserData() {
  if (typeof window === 'undefined') return {};
  let userData = window.localStorage.getItem('userAuth');
  userData = JSON.parse(userData);
  return userData;
}

const convertTimeToSeconds = (hms) => {
  const a = hms.split(':');
  const seconds = +a[0] * 3600 + +a[1] * 60 + +a[2];
  return seconds;
};

const secondsToHms = (d) => {
  let num = d;
  num = Number(d);
  const h = Math.floor(num / 3600);
  const m = Math.floor((num % 3600) / 60);
  const s = Math.floor((num % 3600) % 60);

  const hDisplay = h > 9 ? h : `0${h}`;
  const mDisplay = m > 9 ? m : `0${m}`;
  const sDisplay = s > 9 ? s : `0${s}`;
  return `${hDisplay}:${mDisplay}:${sDisplay}`;
};

function decodeBase64String(base64String) {
  try {
    const decodedString = decodeURIComponent(atob(base64String));
    return JSON.parse(decodedString);
  } catch (error) {
    console.error('Base64 Decoding Error:', error.message);
    return null;
  }
}

function encodeBase64String(input) {
  const stringifiedInput = JSON.stringify(input);
  try {
    const base64String = btoa(encodeURIComponent(stringifiedInput));
    return base64String;
  } catch (error) {
    console.error('Base64 Encoding Error:', error.message);
    return null;
  }
}

const AwshandleFetch = async (url, options = {}) => {
  const token = getCookieValue('userToken');
  let authToken = {};
  if (token) {
    authToken = { Auth: `Bearer ${token}`, 'device-type': '4', 'Version-Code': '21' };
  }
  try {
    const response = await fetch(url, {
      // credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        ...authToken,
      },
      ...options,
    });
    const data = await response.json();
    // eslint-disable-next-line no-debugger
    // console.log(data);

    if (!response.ok) {
      throw new Error(data?.message || data?.error?.message || 'An error occurred while fetching data.');
    }

    return data;
  } catch (error) {
    console.error('Fetch Error:', error.message);
    console.log(error.message || 'Failed to fetch data.');
    return false;
  }
};

// eslint-disable-next-line camelcase
// function get_keysFILE(key, string) {
//   const key1 = key.split('');
//   const string1 = string.split('');
//   let res = '';
//   string1.forEach((el) => {
//     res += key1[el];
//   // eslint-disable-next-line no-trailing-spaces
//   });
//   return res;
// }

// function decryptDataForAws(encryptedData, token) {
//   const C = CryptoJS;
//   // @)!%)##11*1)%#!)===:<?#<>>VV\V<#>?<

//   let Key = '!*@#)($^%1fgv&C=';
//   let IV = '?\\:><{}@#Vjekl/4';
//   if (token) {
//     // eslint-disable-next-line no-use-before-define
//     Key = get_keysFILE(Key, token);
//     // eslint-disable-next-line no-use-before-define
//     IV = get_keysFILE(IV, token);
//   }

//   // 4. Use decrypt instead of encrypt
//   const decryptedText = C.AES.decrypt(encryptedData, C.enc.Utf8.parse(Key), {
//     keySize: 128 / 16,
//     iv: C.enc.Utf8.parse(IV),
//     mode: C.mode.CBC,
//     padding: C.pad.Pkcs7,
//   });

//   // 5. Use decryptedText instead of encryptedData
//   return decryptedText.toString(CryptoJS.enc.Utf8);
// }

// Helper function to asses type of DRM supported

const defaultConfig = [
  {
    initDataTypes: ['cenc'],
    audioCapabilities: [
      {
        contentType: 'audio/mp4;codecs="mp4a.40.2"',
      },
    ],
    videoCapabilities: [
      {
        contentType: 'video/mp4;codecs="avc1.42E01E"',
      },
    ],
  },
];

const testKeySystem = ({ ks }) => navigator.requestMediaKeySystemAccess(ks, defaultConfig);

const isMediaKeySupported = async (keySystem) => {
  if (!navigator.requestMediaKeySystemAccess) return false;

  try {
    const access = await testKeySystem(keySystem);
    await access.createMediaKeys();
    return true;
  } catch {
    return false;
  }
};

export const isPlayreadyLegacySupported = async () => isMediaKeySupported({ ks: 'com.microsoft.playready' });

export const isPlayreadySupported = async () => isMediaKeySupported({ ks: 'com.microsoft.playready.recommendation' });

export const isPlayreadyHardwareSupported = async () => isMediaKeySupported({
  ks: 'com.microsoft.playready.recommendation.3000',
});

export const isPlayreadyChromecastSupported = async () => isMediaKeySupported({ ks: 'com.chromecast.playready' });

export const isWidevineSupported = async () => isMediaKeySupported({ ks: 'com.widevine.alpha' });

export const isModernFairplaySupported = async () => isMediaKeySupported({ ks: 'com.apple.fps' });
export const isLegacyFairplaySupported = async () => isMediaKeySupported({ ks: 'com.apple.fps.1_0' });

async function isFairplaySupported() {
  // Check modern FairPlay support first
  if (await isModernFairplaySupported()) {
    return true;
  }

  // If modern FairPlay is not supported, check legacy FairPlay
  return isLegacyFairplaySupported();
}
// DRM Helpers end

function formatScheduleTime(timestamp) {
  const date = new Date(timestamp);
  let hours = date.getHours();
  const minutes = date.getMinutes();
  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12;
  // eslint-disable-next-line no-unneeded-ternary
  hours = hours ? hours : 12;
  const minutesFormatted = minutes < 10 ? `0${minutes}` : minutes;
  return `${hours}:${minutesFormatted} ${ampm}`;
}
// duration convert
const formatSecondsToDynamicTime = (totalSeconds) => {
  const safeSeconds = Math.max(0, Math.floor(totalSeconds || 0));
  const hours = Math.floor(safeSeconds / 3600);
  const minutes = Math.floor((safeSeconds % 3600) / 60);
  const seconds = safeSeconds % 60;
  const format = (unit) => String(unit).padStart(2, '0'); // Ensure two-digit format

  if (hours > 0) {
    return `${format(hours)}:${format(minutes)}:${format(seconds)}`;
  // eslint-disable-next-line no-else-return
  } else {
    return `${format(minutes)}:${format(seconds)}`;
  }
};

//  filter live class which is going to live in 30 minutes

// eslint-disable-next-line no-unused-vars
function filterLiveClasses(entities) {
  console.log('entities', entities);
  const currentTime = Date.now(); // Current timestamp in milliseconds
  let TIMER_MINUTES = 30 * 60 * 1000; // 30 minutes in milliseconds is default

  const liveClassDetails = entities.filter((entity) => {
    if (entity.subType === 'LiveClass' && entity?.timerInfo?.showTimer && entity?.timerInfo?.secondRemaining) {
      TIMER_MINUTES = entity.timerInfo.secondRemaining * 1000;
    }

    return (
      entity.subType === 'LiveClass'
      && entity.liveAt
      && typeof entity.liveAt === 'number'
      // && entity.liveAt - currentTime > 0
      && entity.liveAt - currentTime <= TIMER_MINUTES
      && entity.status !== ('Completed' || 'Cancelled')
    );
  });
  return {
    liveClassDetails: liveClassDetails || null,
  };
}

// convert time stemp in time or date
function formatDateTime(timestamp) {
  const date = new Date(timestamp);
  // eslint-disable-next-line no-restricted-globals
  if (isNaN(date)) {
    return { date: 'Invalid Date', time: 'Invalid Time' };
  }

  const dateOptions = { day: 'numeric', month: 'short', year: 'numeric' };
  const timeOptions = {
    hour: '2-digit', minute: '2-digit', hour12: true,
  };
  const formattedDate = date.toLocaleDateString('en-US', dateOptions);
  const formattedTime = date.toLocaleTimeString('en-US', timeOptions);
  return {
    date: formattedDate,
    time: formattedTime,
  };
}

function deleteCookie(name) {
  document.cookie = `${name}=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
}
const loggoedOutMsg = 'You have been logged out from this device due to being logged in on another device.';

function clearUserSession() {
  localStorage.clear();
  const popupcontainer = `<div style="position: fixed;top: 0;right: 0;bottom: 0;left: 0;background: #0000001a;border-radius: 4px;display: flex;z-index: 99999999999;justify-content: center;align-items: center;">
      <div style="width: 500px;text-align: center;padding:50px 30px;background-color: white;border-radius: 8px;margin:20px;">
          <p style="font-weight: 700;font-size: 18px;color:#dc3f51;">${loggoedOutMsg}</p>
      
      </div>
  </div>`;
  const newElement = document.createElement('div');
  newElement.innerHTML = popupcontainer;
  // adding a new element at the end of the body
  document.body.appendChild(newElement);
  setTimeout(() => {
    const arr = ['userToken', 'userDamsToken', 'userId'];
    arr.forEach((item) => {
      deleteCookie(item);
    });
    window.location.href = '/prep/home';
  }, 3000);
}
function getAuthToken() {
  // temp token
  const token = '';

  return getCookieValue('userToken') || token;
}

function capitalizeFirstLetter(sentence) {
  return sentence.replace(/\b\w/g, (char) => char.toUpperCase());
}

function isRelativePath(path) {
  return !path?.startsWith('http') && !path?.includes(':');
}

function getCurrentOrgName() {
  const orgDetails = getCurrentOrganization();
  return orgDetails?.organizationName;
}
// end
function domainBaseUrl() {
  return window.location.origin;
}
const fetchImage = async (docurl) => {
  const GET_SECURE_IMAGE_URL = `${process.env.NEXT_PUBLIC_CORE_API_HOST}/auth/get-document-content`;
  const organization = getCurrentOrganization();
  const token = getAuthToken();
  const myHeaders = new Headers();
  myHeaders.append('organization', organization?.orgId || 'your-default-org-id');
  myHeaders.append('device-type', '4');
  myHeaders.append('version-code', '22');
  myHeaders.append('account-role', 'student');
  myHeaders.append('Authorization', `Bearer ${token}`);

  const requestOptions = {
    method: 'GET',
    headers: myHeaders,
    redirect: 'follow',
  };

  try {
    const response = await fetch(`${GET_SECURE_IMAGE_URL}/${docurl}`, requestOptions);
    const blob = await response.blob();

    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        resolve(reader.result); // this will be a base64 data URL
      };
      reader.readAsDataURL(blob);
    });
  } catch (err) {
    console.error('Error loading image', err);
    return null;
  }
};
function checkProfileIncomplete() {
  let profileComplete = window.localStorage.getItem('userAuth');
  if (profileComplete && profileComplete !== null) {
    profileComplete = JSON.parse(profileComplete);
    if (!profileComplete.isPhoneVerified) {
      return { mobile: profileComplete.isPhoneVerified };
    } if (!profileComplete.isEmailVerified) return { email: profileComplete.isEmailVerified };
  }
  return null;
}

// Utility to detect WebView
function isWebView() {
  if (typeof window === 'undefined') return false;

  const ua = navigator.userAgent || navigator.vendor || '';

  // ----- Android WebView -----
  const isAndroid = /Android/.test(ua);
  const isAndroidWebView = (
    /; wv\)/.test(ua) // 'wv' flag in user agent
    || (window.Android && typeof window.Android === 'object') // injected Android interface
  );

  // ----- iOS WebView -----
  const isIOS = /iphone|ipod|ipad/i.test(ua);
  const isSafari = /safari/i.test(ua);
  const isIOSWebView = isIOS && !isSafari;

  // Optional: support for custom flags
  const hasGlobalIOSFlag = globalThis.isiOSApp || process.isIOSWebView;
  const hasGlobalWebViewFlag = process.isWebView;

  return (
    (isAndroid && isAndroidWebView)
    || isIOSWebView
    || hasGlobalIOSFlag
    || hasGlobalWebViewFlag
  );
}
function indexToAlphabet(index) {
  if (index < 0) {
    throw new Error('Index must be non-negative');
  }

  if (index < 26) {
    // Single letter: A-Z
    return String.fromCharCode(65 + index);
  }
  // Multiple letters: AA, AB, AC, ... BA, BB, ...
  let result = '';
  let num = index;

  while (num >= 0) {
    result = String.fromCharCode(65 + (num % 26)) + result;
    num = Math.floor(num / 26) - 1;
    if (num < 0) break;
  }

  return result;
}
function indexToAlphabetOneBased(index) {
  if (index < 1) {
    throw new Error('Index must be positive (1-based)');
  }

  return indexToAlphabet(index - 1);
}
// ms into minutes
const formatTime = (secondsInput) => {
  const minutes = Math.floor(secondsInput / 60);
  const seconds = secondsInput % 60;
  return seconds > 50 ? `${minutes + 1}` : `${minutes}`;
};

function getAuthObject() {
  const token = typeof window === 'undefined' ? '' : getCookieValue('userToken');
  const authObj = token ? { Authorization: `Bearer ${token}` } : {};
  return authObj;
}
// date format reading
// const ShortDateformat = (date) => {
//   if (!date) return 'N/A';
//   const d = new Date(date);
//   const day = String(d.getDate()).padStart(2, '0');
//   const month = String(d.getMonth() + 1).padStart(2, '0');
//   const year = String(d.getFullYear()).slice(-2);
//   return `${day}-${month}-${year}`;
// };
const ShortDateformat = (date) => {
  if (!date) return 'N/A';
  const d = new Date(date);
  const options = { month: 'short', day: 'numeric', year: 'numeric' };
  return d.toLocaleDateString('en-US', options);
};

// ---------sanities html tag-----
const cleanHtml = (html) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');

  // Remove <style> tags
  doc.querySelectorAll('style').forEach((el) => el.remove());

  // Remove style attribute(inline style)
  doc.querySelectorAll('p[style], div[style]').forEach((el) => {
    el.removeAttribute('style');
  });

  // Remove empty elements
  const isEmpty = (el) => {
    // safe media tags
    const keepTags = ['IMG', 'VIDEO', 'AUDIO', 'IFRAME', 'SVG', 'MATH', 'BR', 'HR'];

    if (keepTags.includes(el.tagName)) return false;

    return (
      el.children.length === 0
      && el.textContent.replace(/\u00A0/g, '').trim() === ''
    );
  };

  doc.querySelectorAll('*').forEach((el) => {
    if (isEmpty(el)) {
      el.remove();
    }
  });

  return doc.body.innerHTML;
};
// -----------------------------

const normalizeChartData = (data, bars) => data.map((item) => {
  const updated = { ...item };

  bars.forEach((bar) => {
    if (updated[bar.key] < 0) {
      updated[bar.key] = 0;
    }
  });

  return updated;
});

// covert in hh:mm:ss: formate
const convertToHHMMSS = (minutes) => {
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  const seconds = 0;

  return [hours, mins, seconds]
    .map((unit) => String(unit).padStart(2, '0'))
    .join(':');
};
//--------------------------
// add param to url
const addParamsToUrl = (url, params = {}) => {
  const urlObj = new URL(url, window.location.origin);
  Object.entries(params).forEach(([key, value]) => {
    if (value !== null && value !== undefined) {
      urlObj.searchParams.set(key, value); // overwrites if already exists
    }
  });

  return urlObj.pathname + urlObj.search;
};
// const addParamsToUrl = (url, params) => {
//   const queryString = Object.entries(params)
//     // eslint-disable-next-line no-unused-vars
//     .filter(([_, value]) => value !== null && value !== undefined)
//     .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
//     .join('&');

//   if (!queryString) return url;

//   return url.includes('?')
//     ? `${url}&${queryString}`
//     : `${url}?${queryString}`;
// };
// remove helper
const removeParamsFromUrl = (url, params = []) => {
  const urlObj = new URL(url, window.location.origin);
  params.forEach((param) => urlObj.searchParams.delete(param));
  return urlObj.pathname + urlObj.search;
};

export {
  noop, handleFetch, handleFileUpload, getUserData, convertTimeToSeconds, secondsToHms,
  decodeBase64String, encodeBase64String, getBaseDomain, getCurrentOrganization, AwshandleFetch,
  isFairplaySupported, formatScheduleTime, formatSecondsToDynamicTime, formatDateTime,
  getCookieValue, filterLiveClasses, clearUserSession, getAuthToken, capitalizeFirstLetter,
  isRelativePath, deleteCookie, getCurrentOrgName, domainBaseUrl, getRootDomainForCookie,
  fetchImage, checkProfileIncomplete, indexToAlphabet, indexToAlphabetOneBased, isWebView, getAuthObject,
  getOrganizationPropertiesByHost, formatTime, ShortDateformat, handlePresignedUpload, cleanHtml, normalizeChartData, convertToHHMMSS, addParamsToUrl, removeParamsFromUrl,
};
